<template>
  <ConfigErrorBoundary>
    <FileCompressor
      :config="compressorConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileCompressor from './FileCompressor.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateCompressorConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const compressorConfig = parseAndValidateCompressorConfig('png-compressor', 'PNG Compressor');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[PNG Compressor] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[PNG Compressor] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[PNG Compressor] Batch cleared');
}

function handleError(error: Error) {
  console.error('[PNG Compressor] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[PNG Compressor] Credits updated:', credits);
}
</script>
